<!--  -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="params" :rules="rules" label-width="90px">
      <el-form-item label="上传文件:">
        <el-upload
          drag
          :limit="limitNum"
          :auto-upload="true"
          accept=".xlsx, .xls"
          :action="action"
          :before-upload="beforeUploadFile"
          :on-change="fileChange"
          :on-exceed="exceedFile"
          :on-success="handleSuccess"
          :on-error="handleError"
          :file-list="fileList"
          name="upload"
          :headers="header"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx或xls文件，且不超过10M</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align:center">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import API from "@/api";

export default {
  data() {
    return {
      title: "导入excel文件",
      dialogVisible: false,
      flag: false,
      action: baseConfig.baseServerUrl + "/comment/importExcel",
      header: {
        Authorization: local.get("userInfo") ? local.get("userInfo").token : "",
      },
      rules: {},
      params: {},
      limitNum: 1, // 上传excell时，同时允许上传的最大数
      fileList: [], // excel文件列表
    };
  },

  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          this.$emit("handleList");
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    }, // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.warning(
        `只能选择 ${this.limitNum} 个文件，当前共选择了 ${
          files.length + fileList.length
        } 个`
      );
    },
    // 文件状态改变时的钩子
    // eslint-disable-next-line no-unused-vars
    fileChange(file, fileList) {
      this.fileList.push(file.raw);
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xlsx" || extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx或.xls的文件");
      }
      if (size > 10) {
        this.$message.warning("文件大小不得超过10M");
      }
    },
    // 文件上传成功时的钩子
    // eslint-disable-next-line no-unused-vars
    handleSuccess(res, file, fileList) {
      this.$message.success("文件上传成功");
    },
    // 文件上传失败时的钩子
    // eslint-disable-next-line no-unused-vars
    handleError(err, file, fileList) {
      this.$message.error("文件上传失败");
    },

    uploadFile() {
      if (this.fileList.length === 0) {
        this.$message.warning("请上传文件");
      } else {
        let form = new FormData();
        // form.append('upload', this.fileList);
        // this.$axios({
        //   method:"post",
        //   url: "/statistical/uploadbug",
        //   headers:{
        //     'Content-type': 'multipart/form-data'
        //   },
        //   data:form
        // })
        API.iExcel(form).then(
          (res) => {
            window.console.log(res);
          },
          (err) => {
            window.console.log(err);
          }
        );
      }
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    open() {
      this.dialogVisible = true;
      this.title = "导入excel表";
    },
  },
};
</script>

<style lang='' scoped>
</style>